import { Pipe, PipeTransform } from '@angular/core';
import { Asset } from 'interfaces/asset.model';

/**
 * Generated class for the FilterAssetsByPackagePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterAssetsByPackage',
})
export class FilterAssetsByPackagePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(assets: Asset[], selectedPackage: any): any {
    if (!assets || typeof selectedPackage == "undefined") {
      return assets;
    } else {
      return assets.filter(asset => {
        return (selectedPackage.attachments.indexOf(asset.AssetId) > -1)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-assets-by-package/filter-assets-by-package.ts